import React from 'react';

import { injectIntl } from 'react-intl';
import { useOwner } from '../context/context.js';

import OwnerMenu from '../ui_items/OwnerMenu.js';

const StatsMainMenu = (props) => {
	const owner = useOwner();

	const promotion = owner?.promotion?.Promotion ?? false;
	if(promotion === false || parseInt(promotion.promo_type) < 1) return null;
	const roulette_enabled = promotion?.roulette_enabled ?? false;
	const multiparticipation = promotion?.multi_participation ?? false;

	const is_basic = (parseInt(promotion.promo_type) == 0) ? true : false;
	const selected = props?.selected ?? false;

	let _s = {};

	_s.general = {
		title:"General",
		items:[{
			url:`/promotions/profile/${promotion.id}`,
			icon:'knk-home',
			selected:(selected == 'profile') ? true : false,
			children:"Home",
		}],
	}

	_s.insights = {
		title:"Insights",
		items:[{
			enabled:true,
			url:`/insights/participants/${promotion.id}`,
			icon:'knk-users',
			selected:(selected == 'participants') ? true : false,
			children:(multiparticipation) ? "Unique participants" : "Participants",
		}, {
			enabled:(multiparticipation) ? true : false,
			url:`/insights/participations/${promotion.id}`,
			icon:'knk-entries',
			selected:(selected == 'participations') ? true : false,
			children:"Participations",
		}],
	}



/*	const insights = [{
		key:'participants',
		icon:'knk-users',
		title:,
		link:`/insights/participants/${promotion.id}`,
		description:i18n("Main information about registered users: number of registrations per day / hour, device used, etc."),
	}];

	if(multiparticipation) {
		insights.push({
			key:'participations',
			icon:'knk-entries',
			title:"Participations",
			link:`/insights/participations/${promotion.id}`,
			description:i18n("Data about the participations of the registered users: participations per day, devices used, etc."),
		});
	}

	insights.push({
		key:'votes',
		icon:'knk-like',
		title:"Votes",
		link:`/insights/votes/${promotion.id}`,
		reason:'p1',	// !basic || stats_addon
		description:i18n("Main information about votes to registered users: number of votes per day / hour, device used, etc."),
	});

	insights.push({
		key:'visits',
		icon:'knk-google-analytics',
		title:"Visits",
		link:`/insights/visits/${promotion.id}`,
		reason:'p1',	// !basic || stats_addon
		description:i18n("Data about the visits received in your promotion: pages views, unique visits and conversion rates."),
	});

	insights.push({
		key:'shares',
		icon:'knk-share',
		title:"Shares",
		link:`/insights/shares/${promotion.id}`,
		reason:'p1',	// !basic || stats_addon
		description:i18n("Number of times that the promotion has been shared, detail of the social networks used, shared content, etc."),
	});

	insights.push({
		key:'mynetworks',
		icon:'knk-networks',
		title:"My Networks",
		link:`/insights/mynetworks/${promotion.id}`,
		reason:'p7',	// mynetworks
		description:i18n("Percentages and absolute values about the clicks received in each social network displayed in %s.").replace("%s", i18n("My Networks")),
	});

	insights.push({
		key:'sources',
		icon:'knk-promote',
		title:"Sources",
		link:`/insights/sources/${promotion.id}`,
		reason:'p1',	// !basic || stats_addon
		description:i18n("Data about the origin of participants: social networks, referral sites, newsletter, UTMs tracking, widgets, etc."),
	});

	if(!is_basic && roulette_enabled) {
		insights.push({
			key:'roulette',
			icon:'knk-roulette',
			title:"Spin the Wheel",
			link:`/insights/roulette/${promotion.id}`,
			description:i18n("Data about the total number of spins in the Spin the wheel, prizes obtained as well as its distribution per day."),
		});
	}

	if(!is_basic) {
		if(is_game) {
			insights.push({
				key:'roulette',
				icon:promotion_type?.icon_class ?? 'knk-edit',
				title:promotion_type?.name ?? "Game",
				link:`/insights/game/${promotion.id}`,
				description:i18n("Percentages and absolute values of the game."),
			});
		} else if(has_quiz && quiz_enabled) {
			insights.push({
				key:'roulette',
				icon:'knk-questions',
				title:"Quiz",
				link:`/insights/quiz/${promotion.id}`,
				description:i18n("Percentages and absolute values of the quiz answers selected by the users."),
			});
		}
	}

	if(!is_basic && !multiparticipation) {
		insights.push({
			key:'iw',
			icon:'knk-winners',
			title:"Instant winners",
			link:`/insights/instant_wins/${promotion.id}`,
			reason:'p8',
			description:i18n("Number of participations and users per day, average of participations per user and other statistics."),
		});
	}

	insights.push({
		key:'prizes',
		icon:'knk-download',
		title:"Prize downloads",
		link:`/insights/prizes/${promotion.id}`,
		reason:'p1',
		description:i18n("The system tracks each time a user downloads the PDF of a prize. Access here the statistics of number of downloads per day and per type of prize."),
	});

	insights.push({
		key:'videos',
		icon:'knk-play-round',
		title:"Video views",
		link:`/insights/video_plays/${promotion.id}`,
		reason:'p1',
		description:i18n("Number of views of the videos you have embedded in the pages of the promotion."),
	});*/






	return (
		<OwnerMenu sections={Object.values(_s)} />
	)
}

export default injectIntl(StatsMainMenu);